module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/star1.a7dfb93c.png";